import { combineReducers } from 'redux';
import actions from '../constants/actionTypes';
import appReducer from '../layout/reducers';
import authReducer from '../authentication/reducers';
import universalReducer from '../layout/components/UniversalModal/reducers';
import loginReducer from '../pages/Login/reducers';
import settingsReducer from '../pages/Setting/reducers';
import orderReducer from '../pages/Order/OrderManagement/reducers';
import dishReportReducer from '../pages/Order/ReportDish/reducers';
import restaurantReportReducer from '../pages/Order/ReportRestaurant/reducers';
import nowShipGeneralReducer from '../pages/NowShip/reducers';
import orderManagementShipReducer from '../pages/NowShip/OrderManagementNowShip/reducers';
import nowShipBookingReducer from '../pages/NowShip/BookingNowShip/reducers';
import reportShipReducer from '../pages/NowShip/ReportNowShip/reducers';
import walletManagementReducer from '../pages/MerchantWallet/WalletManagement/reducers';
import tableReducer from '../pages/Table/TableManagement/reducers';
import nowPortalOrderReducer from '../pages/NowPortal/NowPortalOrder/reducers';
import nowPortalWithdrawReducer from '../pages/NowPortal/NowPortalWithdraw/reducers';
import chatBoxReducer from '../pages/ChatBox/reducers';
import exportRestaurantReducer from '../pages/Order/ExportRestaurant/reducers';
import configStaffReducer from '../pages/Staff/reducers';
import transferOrderReducer from '../pages/Order/OrderManagement/OrderDetail/TransferOrder/reducers';

const combineReducer = combineReducers({
  app: appReducer,
  universalModal: universalReducer,
  auth: authReducer,
  login: loginReducer,
  setting: settingsReducer,
  chat: chatBoxReducer,
  order: orderReducer,
  transferOrder: transferOrderReducer,
  report: combineReducers({
    dish: dishReportReducer,
    restaurant: restaurantReportReducer,
    export: exportRestaurantReducer,
  }),
  ship: combineReducers({
    general: nowShipGeneralReducer,
    order: orderManagementShipReducer,
    booking: nowShipBookingReducer,
    report: reportShipReducer,
  }),
  wallet: combineReducers({
    userWallet: walletManagementReducer,
  }),
  table: combineReducers({
    order: tableReducer,
  }),
  portal: combineReducers({
    order: nowPortalOrderReducer,
    withdraw: nowPortalWithdrawReducer,
  }),
  staff: configStaffReducer,
});

const rootReducer = (state, action) => {
  let newState = state;
  if (action.type === actions.INIT_SESSION) {
    newState = undefined;
  }
  return combineReducer(newState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./foody/src/redux/rootReducer.js